"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.line = exports.orderOptionsContainer = void 0;

var _util = require("../../../util");

const orderOptionsContainer = () => ({
  width: '90%'
});

exports.orderOptionsContainer = orderOptionsContainer;

const line = ({
  theme,
  cssProps: {
    color
  }
}) => ({
  width: 2,
  height: 40,
  borderRadius: 15,
  background: (0, _util.color)(theme, "background.".concat(color))
});

exports.line = line;
//# sourceMappingURL=StrategyOrderCell.style.js.map